<div>{{ currencyDisplay }}</div>
<ion-input
  type="number"
  [formControl]="amountFormControl"
  [ionFormlyAttributes]="field"
  (ionChange)="inputChanged()"
></ion-input>
